import { metaAccount } from '@/router/meta-config'
const permissionKey = 'CITY'

export default [
  {
    path: '/cities',
    name: 'page-cities',
    component: () => import('@/pages/cities'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/city/new',
    name: 'page-city-new',
    component: () => import('@/pages/city'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/city/:id',
    name: 'page-city',
    component: () => import('@/pages/city'),
    props: (route) => ({ id: route.params.id }),
    meta: {
      ...metaAccount,
      permissionKey
    }
  }
]
